import { BusinessDays } from './business-days'
import { DaysOfWeek } from './date-util'

export default class ClinicConstantsMenProd {
  /* clinic情報 */
  static SAPPORO = {
    medicalBusinessId: '362a8a35-7a66-4e30-be2a-d87b22723ad4',
    name: '札幌',
    clinicId: '3139273e84784bd0baadbce33fd2e617',
    clinicalDepartmentId: '',
    treatmentCourseId: '',
    businessDays: BusinessDays,
    nonTargetDays: []
  }

  static TOKYO = {
    medicalBusinessId: '362a8a35-7a66-4e30-be2a-d87b22723ad4',
    name: '東京',
    clinicId: 'de6d5cc1e6844764853da3be9c168f44',
    clinicalDepartmentId: '',
    treatmentCourseId: '',
    businessDays: BusinessDays,
    nonTargetDays: []
  }

  static SINJUKU = {
    medicalBusinessId: '362a8a35-7a66-4e30-be2a-d87b22723ad4',
    name: '新宿',
    clinicId: '263e17b599f24993acf930a92ee29c04',
    clinicalDepartmentId: '',
    treatmentCourseId: '',
    businessDays: BusinessDays,
    nonTargetDays: []
  }

  static NAGOYA = {
    medicalBusinessId: '362a8a35-7a66-4e30-be2a-d87b22723ad4',
    name: '名古屋',
    clinicId: '6feed6df81fa445a978e0d63f6a9c503',
    clinicalDepartmentId: '',
    treatmentCourseId: '',
    businessDays: BusinessDays,
    nonTargetDays: { [DaysOfWeek.WED]: { am: false, pm: false } }
  }

  static OSAKA = {
    medicalBusinessId: '362a8a35-7a66-4e30-be2a-d87b22723ad4',
    name: '大阪',
    clinicId: 'bb9d3f26e7e440128d46d8ca7adc729f',
    clinicalDepartmentId: '',
    treatmentCourseId: '',
    businessDays: BusinessDays,
    nonTargetDays: []
  }

  static FUKUOKA = {
    medicalBusinessId: '362a8a35-7a66-4e30-be2a-d87b22723ad4',
    name: '福岡',
    clinicId: '9bebedd2a20c44f0a4f42a9e63c04ccf',
    clinicalDepartmentId: '',
    treatmentCourseId: '',
    businessDays: BusinessDays,
    nonTargetDays: { [DaysOfWeek.WED]: { am: false, pm: true } }
  }

  static CLINICS = [
    ClinicConstantsMenProd.SAPPORO,
    ClinicConstantsMenProd.TOKYO,
    ClinicConstantsMenProd.SINJUKU,
    ClinicConstantsMenProd.NAGOYA,
    ClinicConstantsMenProd.OSAKA,
    ClinicConstantsMenProd.FUKUOKA
  ]
}
